import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppAuthProvider } from './contexts/AppAuthContext';
import { SupplierAuthProvider } from './contexts/SupplierAuthContext';
import { AppRoutes } from './routes/AppRoutes';

function App() {
  return (
    <BrowserRouter>
      <AppAuthProvider>
        <SupplierAuthProvider>
          <AppRoutes />
        </SupplierAuthProvider>
      </AppAuthProvider>
    </BrowserRouter>
  );
}

export default App;
